import { Application, Sprite, Texture, Graphics, Container, utils } from 'pixi.js';
import { gsap } from 'gsap';
import { debounce } from "../../utils";

class HeroMyFirst16 {
    constructor(el) {
        this.el = el;
        this.hero = el.closest('.my-first-16-hero');
        this.contentWrapper = this.hero.querySelector('.container');
        this.initiated = false;
        this.breakpoint = this.getBreakpoint();
        this.setSizes();
        this.init();
    }

    isMobile() {
        return window.innerWidth < 768;
    }

    isTablet() {
        return window.innerWidth < 1140;
    }

    calculateCircles() {
        this.circlesGap = this.isMobile() ? 6 : 8;

        if(this.isTablet()) {
            this.circleSize = 30;
            this.circlesByColumn = Math.ceil(this.elHeight / (this.circleSize + this.circlesGap)) + 1;
        } else {
            this.circlesByColumn = 13;
            this.circleSize = this.elHeight / (this.circlesByColumn - 1) - this.circlesGap;
        }

        this.circlesByRow = Math.ceil(this.elWidth / (this.circleSize + this.circlesGap)) + 1;
    }

    generateCircles() {
        this.circles = [];
        this.filledCircles = [];

        if(!this.circlesContainer) {
            this.circlesContainer = new Container();
            this.app.stage.addChild(this.circlesContainer);
        }

        this.circlesContainer.pivot.x = this.elWidth;
        this.circlesContainer.position.x = this.elWidth;

        for(let i = 0; i < this.circlesByRow * this.circlesByColumn; i++) {
            const circle = new Graphics();
            circle.width = this.circleSize;
            circle.height = this.circleSize;
            circle.x = (i % this.circlesByRow) * (this.circleSize + this.circlesGap);
            circle.y = Math.floor(i / this.circlesByRow) * (this.circleSize + this.circlesGap);
            circle.lineStyle(2, 0x0A3954, 1);
            circle.drawCircle(this.circleSize - this.circlesGap / 2, this.circleSize - this.circlesGap / 2, this.circleSize / 2);
            circle.endFill();
            circle.pivot.x = this.circleSize;
            circle.pivot.y = this.circleSize;

            if(!this.initiated) {
                circle.alpha = 0;
                circle.scale.set(0.5);
            }

            this.circles.push(circle);
            this.circlesContainer.addChild(circle);

            const filledCircle = new Graphics();
            filledCircle.width = this.circleSize;
            filledCircle.height = this.circleSize;
            filledCircle.x = (i % this.circlesByRow) * (this.circleSize + this.circlesGap);
            filledCircle.y = Math.floor(i / this.circlesByRow) * (this.circleSize + this.circlesGap);
            filledCircle.beginFill(0x0b4756, 1);
            filledCircle.lineStyle(2, 0x0b4756, 1);
            filledCircle.drawCircle(this.circleSize - this.circlesGap / 2, this.circleSize - this.circlesGap / 2, this.circleSize / 2);
            filledCircle.endFill();
            filledCircle.pivot.x = this.circleSize;
            filledCircle.pivot.y = this.circleSize;
            filledCircle.alpha = 0;

            this.filledCircles.push(filledCircle);
            this.circlesContainer.addChild(filledCircle);
        }
    }

    initLetters() {
        this.lettersTopSVG = [
            `<svg width="50" height="68" viewBox="0 0 25 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.36152 33.6846H0.617188V0.977295H5.36152V5.65226H7.73147V7.98975H10.1014V10.3229H14.8458V7.98975H17.2157V5.65226H19.5901V0.977295H24.33V33.6846H19.5901V12.6604H17.2157V14.9978H14.8458V19.6684H10.1014V14.9978H7.73147V12.6604H5.36152V33.6846Z" fill="#A77AD7"/></svg>`,
            `<svg width="48" height="68" viewBox="0 0 24 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.4423 33.6841H9.69801V22.0054H7.32805V19.668H4.95368V17.3305H2.58373V14.9974H0.213776V0.976807H4.95368V12.6599H7.32805V14.9974H9.69801V17.3305H14.4423V14.9974H16.8123V12.6599H19.1823V0.976807H23.9266V14.9974H21.5566V17.3305H19.1823V19.668H16.8123V22.0054H14.4423V33.6841Z" fill="#A77AD7"/></svg>`,
            `<svg width="50" height="68" viewBox="0 0 25 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24.3383 0.976807V5.65177H5.36981V14.9974H19.594V19.668H5.36981V33.6841H0.625488V0.976807H24.3383Z" fill="#A77AD7"/></svg>`,
            `<svg width="30" height="68" viewBox="0 0 15 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.555298 33.6841V29.0135H5.19027V5.65177H0.555298V0.976807H14.4559V5.65177H9.82525V29.0135H14.4559V33.6841H0.555298Z" fill="#A77AD7"/></svg>`,
            `<svg width="48" height="68" viewBox="0 0 24 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.7544 19.663H5.46617V33.6754H0.885437V0.976807H19.2041V3.31367H21.4923V5.65053H23.7806V14.9936H21.4923V17.3305H19.2041V19.6673H14.6234V22.0042H16.9116V24.3411H19.1998V26.6779H21.4881V29.0148H23.7763V33.6841H19.1956V31.3473H16.9073V29.0104H14.6191V26.6736H12.3309V24.3367H10.0426V21.9998H7.7544V19.663ZM5.46617 5.65053V14.9936H16.9159V12.6568H19.2041V7.98739H16.9159V5.65053H5.46617Z" fill="#A77AD7"/></svg>`,
            `<svg width="50" height="68" viewBox="0 0 25 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.0012 5.65177H24.3712V10.3224H19.6313V7.98926H17.2569V5.65177H7.77266V7.98926H5.40271V12.6599H7.77266V14.9974H19.6313V17.3305H22.0012V19.668H24.3712V29.0135H22.0012V31.351H19.6313V33.6841H5.40271V31.351H3.02834V29.0135H0.658386V24.3429H5.40271V26.6761H7.77266V29.0135H17.2569V26.6761H19.6313V22.0054H17.2569V19.668H5.40271V17.3305H3.02834V14.9974H0.658386V5.65177H3.02834V3.31429H5.40271V0.976807H19.6313V3.31429H22.0012V5.65177Z" fill="#A77AD7"/></svg>`,
            `<svg width="50" height="68" viewBox="0 0 25 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.99779 5.65177H0.51355V0.976807H24.2264V5.65177H14.7421V33.6841H9.99779V5.65177Z" fill="#A77AD7"/></svg>`
        ]

        this.lettersBottomSVG = [
            `<svg width="50" height="68" viewBox="0 0 25 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.0012 5.65177H24.3712V10.3224H19.6313V7.98926H17.2569V5.65177H7.77266V7.98926H5.40271V12.6599H7.77266V14.9974H19.6313V17.3305H22.0012V19.668H24.3712V29.0135H22.0012V31.351H19.6313V33.6841H5.40271V31.351H3.02834V29.0135H0.658386V24.3429H5.40271V26.6761H7.77266V29.0135H17.2569V26.6761H19.6313V22.0054H17.2569V19.668H5.40271V17.3305H3.02834V14.9974H0.658386V5.65177H3.02834V3.31429H5.40271V0.976807H19.6313V3.31429H22.0012V5.65177Z" fill="#00A4B1"/></svg>`,
            `<svg width="30" height="68" viewBox="0 0 15 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.524811 33.6596V28.853H5.23894V4.81981H0.524811V0.0131836H14.6672V4.81981H9.95305V28.853H14.6672V33.6596H0.524811Z" fill="#00A4B1"/></svg>`,
            `<svg width="50" height="68" viewBox="0 0 25 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m5.4872 26.676v7.0084h-4.721v-9.3443h2.3605v-2.3368h2.3605v-2.3358h2.3605v-4.6726h-2.3605v-2.3368h-2.3605v-2.3358h-2.3605v-9.3452h4.721v7.0094h2.3605v2.3358h2.3605v2.3358h4.721v-2.3358h2.3605v-2.3358h2.3605v-7.0094h4.721v9.3452h-2.3605v2.3358h-2.3605v2.3368h-2.3605v4.6726h2.3605v2.3358h2.3605v2.3368h2.3605v9.3443h-4.721v-7.0084h-2.3605v-2.3358h-2.3605v-2.3368h-4.721v2.3368h-2.3605v2.3358z" fill="#00A4B1"/></svg>`,
            `<svg width="48" height="68" viewBox="0 0 24 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.44806 4.81981H0.0198364V0.0131836H23.5905V4.81981H14.1622V33.6596H9.44806V4.81981Z" fill="#00A4B1"/></svg>`,
            `<svg width="50" height="68" viewBox="0 0 25 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24.108 0.0131836V4.81981H5.25156V14.4331H19.3939V19.2397H5.25156V28.853H24.108V33.6596H0.537415V0.0131836H24.108Z" fill="#00A4B1"/></svg>`,
            `<svg width="50" height="68" viewBox="0 0 25 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24.108 0.0131836V4.81981H5.25156V14.4331H19.3939V19.2397H5.25156V28.853H24.108V33.6596H0.537415V0.0131836H24.108Z" fill="#00A4B1"/></svg>`,
            `<svg width="50" height="68" viewBox="0 0 25 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.5903 14.4331V33.6596H0.876221V0.0131836H5.5903V7.22313H7.94739V9.62644H10.3045V12.0298H12.6615V14.4331H15.0186V16.8364H17.3756V19.2397H19.7327V0.0131836H24.4468V33.6596H19.7327V26.4497H17.3756V24.0463H15.0186V21.643H12.6615V19.2397H10.3045V16.8364H7.94739V14.4331H5.5903Z" fill="#00A4B1"/></svg>`,
        ]
    }

    generateLetters() {
        this.initLetters();
        this.lettersTop = [];
        this.lettersBottom = [];

        this.lettersTopSVG.forEach((letter, index) => {
            this.lettersTop.push(this.generateLetterSprite(letter, index));
        })

        this.lettersBottomSVG.forEach((letter, index) => {
            this.lettersBottom.push(this.generateLetterSprite(letter, index));
        })
    }

    generateLetterSprite(letterSVG) {
        const sprite = Texture.from(letterSVG);
        const letter = new Sprite(sprite);
        letter.originalWidth = letterSVG.width / 2;
        letter.originalHeight = letterSVG.height / 2;
        letter.scale.set(0.5);
        return letter
    }

    animateCircles() {
        for(let i = 0; i < this.circles.length; i++) {
            const circle = this.circles[i];

            const delayAmount = (i % this.circlesByRow + Math.floor(i / this.circlesByRow)) * 0.04;

            gsap.to(circle, {
                alpha: 1,
                delay: delayAmount,
                duration: 0.5
            });

            gsap.to(circle.scale, {
                x: 1,
                y: 1,
                delay: delayAmount,
                duration: 0.5
            });
        }
        const maxDelay = (this.circlesByRow + this.circlesByColumn) * 0.04;
        setTimeout(() => {
            this.animateFillCircles();
            this.animateLogoCircles();
            this.animateLogoLetters();

            setTimeout(() => {
                this.initiated = true;
            }, 1000);
        }, maxDelay * 1000);
    }

    getNotAnimatedCircleIndex() {
        const notAnimatedCircles = this.filledCircles.filter((circle) => !circle.isAnimated);
        return this.filledCircles.indexOf(notAnimatedCircles[Math.floor(Math.random() * notAnimatedCircles.length)]);
    }

    getAnimatedCirclesCount() {
        return this.filledCircles.filter((circle) => circle.isAnimated).length;
    }

    animateFillCircles() {
        if(this.getAnimatedCirclesCount() <= 3) {
            const index = this.getNotAnimatedCircleIndex();
            const randomCircle = this.filledCircles[index];
            randomCircle.isAnimated = true;
            gsap.to(randomCircle, {alpha: 1, duration: .9, ease: 'none',
                onComplete: () => {
                    gsap.to(randomCircle, {
                        alpha: 0, duration: .9, ease: 'none',
                        onComplete: () => {
                            randomCircle.isAnimated = false;
                        }
                    });
                }
            })
        }

        setTimeout(() => {
            this.animateFillCircles();
        }, 300);
    }

    addLogoSection() {
        this.logoSizeInCircles = 7;
        this.logoSection = new Container();
        const closestRow = Math.floor(this.contentWrapperRight / (this.circleSize + this.circlesGap));
        const pos = this.circles[closestRow].position.x - this.circleSize / 2 - this.circlesGap;
        const sectionSize = this.logoSizeInCircles * (this.circleSize + this.circlesGap);

        if(this.isMobile()) {
            let xPos = this.elWidth / 2 - sectionSize / 2;
            let xPosCircles = Math.floor(xPos / (this.circleSize + this.circlesGap)) + .5;
            let diff = xPos - xPosCircles * (this.circleSize + this.circlesGap) + this.circlesGap / 2;
            this.logoSection.position.set(xPos - diff, this.circleSize / 2);
        } else if(this.isTablet()) {
            let yPos = this.elHeight / 2 - sectionSize / 2;
            let yPosCircles = Math.floor(yPos / (this.circleSize + this.circlesGap)) + .5;
            let diff = yPos - yPosCircles * (this.circleSize + this.circlesGap) + this.circlesGap / 2;
            this.logoSection.position.set(pos - sectionSize, yPos - diff);
        } else {
            let yPos = this.elHeight / 2 - sectionSize / 2;
            let yPosCircles = Math.floor(yPos / (this.circleSize + this.circlesGap)) + .5;
            let diff = yPos - yPosCircles * (this.circleSize + this.circlesGap) + this.circlesGap / 2;
            this.logoSection.position.set(pos - sectionSize, yPos - diff);
        }

        this.app.stage.addChild(this.logoSection);
        this.addLogo();
    }

    addLogo() {
        this.logoSizeInCirclesInner = 5;
        this.logo = new Container();
        this.logoMask = new Container();
        this.logoCircles = [];

        const logoPattern = [
            [1, 0, 1, 1, 1],
            [1, 0, 1, 0, 0],
            [1, 0, 1, 1, 1],
            [1, 0, 1, 0, 1],
            [1, 0, 1, 1, 1],
        ]

        const circlePosInitDelta = (this.circleSize + this.circlesGap) / 2 + this.circleSize + this.circlesGap;

        for(let i = 0; i < this.logoSizeInCirclesInner * this.logoSizeInCirclesInner; i++) {
            const col = i % this.logoSizeInCirclesInner;
            const row = Math.floor(i / this.logoSizeInCirclesInner);

            if(logoPattern[row][col] === 0) {
                continue;
            }

            const circle = new Graphics();
            circle.width = this.circleSize;
            circle.height = this.circleSize;

            circle.x = circlePosInitDelta + col * (this.circleSize + this.circlesGap);
            circle.y = circlePosInitDelta + row * (this.circleSize + this.circlesGap);

            circle.beginFill(0xaa0056, 1);
            circle.lineStyle(2, 0x0A3954, 1);
            circle.drawCircle(0, 0, this.circleSize / 2);
            circle.endFill();
            circle.alpha = 0;
            this.logoCircles.push(circle);
            this.logoMask.addChild(circle);
        }

        const logoBounds = this.logoMask.getBounds();
        const texture = this.createGradientTexture(logoBounds.width, logoBounds.height);
        const logoSprite = new Sprite(texture);
        logoSprite.x = logoBounds.x;
        logoSprite.y = logoBounds.y;
        logoSprite.width = logoBounds.width;
        logoSprite.height = logoBounds.height;
        this.logo.addChild(logoSprite);
        this.logo.mask = this.logoMask;

        this.logoSection.addChild(this.logo);
        this.logoSection.addChild(this.logoMask);

        this.generateLogoWords();
    }

    generateLogoWords() {
        this.generateLetters();

        this.lettersTop.forEach((letter, index) => {
            letter.x = (this.circleSize + this.circlesGap) / 2 + (index) * (this.circleSize + this.circlesGap)
            letter.y = (this.circleSize + this.circlesGap) / 2
            letter.anchor.set(0.5);
            letter.alpha = 0;

            if(this.isTablet()) {
                letter.scale.set(0.25);
            } else {
                letter.scale.set(0.35);
            }

            this.logoSection.addChild(letter);
        })

        this.lettersBottom.forEach((letter, index) => {
            letter.x = (this.circleSize + this.circlesGap) / 2 + (index) * (this.circleSize + this.circlesGap)
            letter.y = (this.circleSize + this.circlesGap) / 2 + (this.circleSize + this.circlesGap) * (this.logoSizeInCircles - 1)
            letter.anchor.set(0.5);
            letter.alpha = 0;

            if(this.isTablet()) {
                letter.scale.set(0.25);
            } else {
                letter.scale.set(0.35);
            }

            this.logoSection.addChild(letter);
        })
    }

    animateLogoLetters() {
        gsap.to([this.lettersTop, this.lettersBottom], {
            alpha: 1,
            duration: 0.75,
            stagger: 0.05,
            ease: 'none',
        });
    }

    animateLogoCircles() {
        // randomize circles
        const randomizedLogoCircles = this.logoCircles.sort(() => Math.random() - 0.5);
        gsap.to(randomizedLogoCircles, {
            alpha: 1,
            duration: 0.75,
            stagger: 0.05,
            ease: 'none',
        });
    }

    createGradientTexture(width, height) {
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');

        const gradient = ctx.createLinearGradient(0, 0, 0, height);
        gradient.addColorStop(0.1591, '#A77AD7');
        gradient.addColorStop(0.2917, '#E28922');
        gradient.addColorStop(0.5795, '#F1C001');
        gradient.addColorStop(0.8902, '#01A4B1');

        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, width, height);

        return Texture.from(canvas);
    }

    init() {
        utils.skipHello();
        this.app = new Application({
            width: this.elWidth,
            height: this.elHeight,
            backgroundAlpha: 0,
            resolution: 2,
            autoResize:true,
            antialias: true,
            autoDensity: true,
        });

        this.el.appendChild(this.app.view);
        this.initScene();
        window.addEventListener('resize', debounce(this.resizeHandler.bind(this), 100));
    }

    initScene() {
        this.calculateCircles();
        this.generateCircles();
        this.addLogoSection();
        this.animateCircles();
    }

    resizeHandler() {
        const previousWidth = this.elWidth;
        this.setSizes();
        if (previousWidth !== this.elWidth) {
            this.resize();
        }
    }

    setSizes() {
        this.elWidth = this.el.offsetWidth;
        this.elHeight = this.el.offsetHeight;
        this.contentWrapperBounds = this.contentWrapper.getBoundingClientRect();
        this.contentWrapperRight = this.contentWrapperBounds.right;
    }

    getBreakpoint() {
        return this.isMobile() ? 'mobile' : (this.isTablet() ? 'tablet' : 'desktop');
    }

    checkBreakpointChange() {
        const previousBreakpoint = this.breakpoint;
        this.breakpoint = this.getBreakpoint();
        return previousBreakpoint !== this.breakpoint;
    }

    resize() {
        this.app.renderer.resize(this.elWidth, this.elHeight);

        if(this.checkBreakpointChange()) {
            this.reinit();
            return;
        }

        const circlesByRow = Math.ceil(this.elWidth / (this.circleSize + this.circlesGap)) + 1;

        if(this.circlesByRow !== circlesByRow) {
            this.circlesByRow = circlesByRow;
            this.circlesContainer.removeChildren();
            this.generateCircles();
        }

        const closestRow = Math.floor(this.contentWrapperRight / (this.circleSize + this.circlesGap));
        const pos = this.circles[closestRow].getGlobalPosition().x - this.circleSize / 2 - this.circlesGap;
        const sectionSize = this.logoSizeInCircles * (this.circleSize + this.circlesGap);

        if(this.isMobile()) {
            let xPos = this.elWidth / 2 - sectionSize / 2;
            let xPosCircles = Math.floor(xPos / (this.circleSize + this.circlesGap)) + .5;
            let diff = xPos - xPosCircles * (this.circleSize + this.circlesGap) + this.circlesGap / 2;
            this.logoSection.position.set(xPos - diff, this.circleSize / 2);
        } else if(this.isTablet()) {
            let yPos = this.elHeight / 2 - sectionSize / 2;
            let yPosCircles = Math.floor(yPos / (this.circleSize + this.circlesGap)) + .5;
            let diff = yPos - yPosCircles * (this.circleSize + this.circlesGap) + this.circlesGap / 2;
            this.logoSection.position.set(pos - sectionSize, yPos - diff);
        } else {
            let yPos = this.elHeight / 2 - sectionSize / 2;
            let yPosCircles = Math.floor(yPos / (this.circleSize + this.circlesGap)) + .5;
            let diff = yPos - yPosCircles * (this.circleSize + this.circlesGap) + this.circlesGap / 2;
            this.logoSection.position.set(pos - sectionSize, yPos - diff);
        }
    }

    reinit() {
        this.circlesContainer.removeChildren();
        this.logoSection.removeChildren();
        this.circlesContainer = null;
        this.logoSection = null;
        this.app.stage.removeChildren();
        this.initiated = false;
        this.initScene();
    }
}

export default HeroMyFirst16;
